// Shopify supplies stock and prices through Liquid; no external inventory API.
(function () {
  async function initializeWarehousePromotions(scope) {
    const warehouseCode = localStorage.getItem('warehouseCode');
    return Promise.all(Array.from(scope.querySelectorAll('[data-warehouse-promo]')).map(async function (root) {
      const data = root.querySelector('[data-warehouse-variants]');
      root.style.display = 'none';
      const variants = await window.SuKarneWarehouse.resolveVariants(JSON.parse(data.textContent));
      if (root.isConnected === false) return;
      const variant = window.SuKarneWarehouse.selectVariant(variants, warehouseCode);
      const available = Boolean(variant?.available);
      root.hidden = !available;
      root.style.display = available ? '' : 'none';
      root.querySelectorAll('[name="id"], [type="submit"]').forEach(input => {
        input.disabled = !available;
        if (variant && input.name === 'id') input.value = String(variant.id);
      });
      if (!variant) return;
      const price = root.querySelector('.cart-summary-item__price');
      price.innerHTML = '<span class="theme-money">' + variant.price_html + '</span>' +
        (variant.compare_at_price > variant.price ? ' <del class="theme-money">' + variant.compare_price_html + '</del>' : '') + variant.unit_price_html;
      root.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variant.id);
        link.href = url.pathname + url.search;
      });
    }));
  }

  async function initializeWarehouseProducts(scope) {
    const promotions = initializeWarehousePromotions(scope);
    const roots = scope.matches?.('[data-warehouse-product]')
      ? [scope]
      : scope.querySelectorAll('[data-warehouse-product]');

    const products = Array.from(roots).map(async function (root) {
      const dataElement = root.querySelector('[data-warehouse-variants]');
      const form = root.querySelector('form.product-form');
      if (!dataElement || !form) return;

      const rawVariants = JSON.parse(dataElement.textContent);
      const validationToken = {};
      root.warehouseValidationToken = validationToken;
      root.warehouseValidationPending = rawVariants.some(variant => variant.is_bundle);
      if (!form.warehousePendingSubmitHandler) {
        form.warehousePendingSubmitHandler = function (event) {
          if (root.warehouseValidationPending) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };
        form.addEventListener('submit', form.warehousePendingSubmitHandler, true);
      }
      if (root.warehouseValidationPending) {
        form.querySelectorAll('[name="id"], [type="submit"]').forEach(input => { input.disabled = true; });
        root.querySelectorAll('.payment-and-quantity, .product-price').forEach(element => { element.classList.add('hidden-pop'); });
        root.querySelectorAll('.productInventory').forEach(element => { element.textContent = 'Consultando disponibilidad del combo…'; });
      }
      const variants = await window.SuKarneWarehouse.resolveVariants(rawVariants);
      if (root.isConnected === false || root.warehouseValidationToken !== validationToken) return;
      root.warehouseValidationPending = false;
      const warehouseCode = (localStorage.getItem('warehouseCode') || '').trim();
      const hasWarehouse = localStorage.getItem('availability') === 'true' && warehouseCode !== '';
      const selectedVariant = hasWarehouse
        ? window.SuKarneWarehouse.selectVariant(variants, warehouseCode)
        : null;
      const canBuy = Boolean(selectedVariant?.available);
      const quantityLimit = selectedVariant?.inventory_management && selectedVariant.inventory_policy === 'deny'
        ? Math.max(0, selectedVariant.inventory_quantity)
        : null;
      const selector = form.querySelector('select[name="id"]');

      root.querySelectorAll('.option-selectors, .original-selector').forEach(element => {
        element.classList.add('hidden-pop');
      });

      // Initialize the theme's existing price/SKU/button updates before selecting.
      // This also covers sections reloaded in the theme editor.
      if (selector && window.theme?.OptionManager && window.jQuery) {
        window.theme.OptionManager.initProductOptions(window.jQuery(selector));
        if (selectedVariant) {
          const option = Array.from(selector.options).find(option => option.value === String(selectedVariant.id));
          if (option && quantityLimit !== null) {
            option.dataset.inventory = String(quantityLimit);
            window.jQuery(option).data('inventory', quantityLimit);
          }
          selector.value = String(selectedVariant.id);
          selector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (selectedVariant && window.theme?.OptionManager && window.jQuery) {
        const productData = window.theme.OptionManager.getProductData(window.jQuery(form));
        const themeVariant = productData?.variants.find(variant => variant.id === selectedVariant.id);
        if (themeVariant) {
          window.theme.OptionManager.updatePrice(themeVariant, window.jQuery(root));
          window.theme.OptionManager.updateSku(themeVariant, window.jQuery(root));
        }
      }

      form.querySelectorAll('[name="id"]').forEach(input => {
        input.disabled = !selectedVariant;
        if (selectedVariant) input.value = String(selectedVariant.id);
      });
      root.querySelectorAll('.product-price').forEach(element => {
        element.classList.toggle('hidden-pop', !selectedVariant);
      });
      root.querySelectorAll('.payment-and-quantity').forEach(element => {
        element.classList.toggle('hidden-pop', !canBuy);
      });
      form.querySelectorAll('[type="submit"]').forEach(button => {
        button.disabled = !canBuy;
      });

      let message = 'Selecciona una tienda para consultar existencias';
      if (hasWarehouse && !selectedVariant) {
        message = variants.some(variant => variant.warehouse_resolution === 'error')
          ? 'No pudimos validar el combo. Recarga la página para intentar de nuevo.'
          : 'Producto no disponible en la tienda seleccionada';
      } else if (selectedVariant) {
        if (root.warehouseValidationToken !== validationToken || !canBuy) {
          message = 'No hay existencias para el producto seleccionado';
        } else if (!selectedVariant.inventory_management) {
          message = 'Producto disponible';
        } else if (selectedVariant.inventory_quantity > 0) {
          const stock = selectedVariant.inventory_quantity;
          message = stock === 1 ? 'Queda 1 existencia disponible' : `Quedan ${stock} existencias disponibles`;
        } else {
          message = 'Disponible bajo pedido';
        }
      }
      root.querySelectorAll('.productInventory').forEach(element => {
        element.textContent = message;
        element.style.color = canBuy ? 'green' : 'red';
        element.setAttribute('aria-live', 'polite');
      });

      function constrainQuantity(input) {
        // AJAX quantity controls remove a line by setting it to zero.
        const minimum = form.classList?.contains('product-form--added') ? 0 : 1;
        const parsedQuantity = parseInt(input.value, 10);
        let quantity = Math.max(minimum, Number.isFinite(parsedQuantity) ? parsedQuantity : 1);
        if (quantityLimit !== null && quantityLimit > 0) quantity = Math.min(quantity, quantityLimit);
        input.value = String(quantity);
      }

      form.querySelectorAll('.qty-adjuster').forEach(adjuster => {
        if (quantityLimit !== null) adjuster.setAttribute('data-limit', String(quantityLimit));
        else adjuster.removeAttribute('data-limit');
        // Existing AJAX quantity controls identify cart lines by variant ID.
        if (selectedVariant) adjuster.setAttribute('data-line-item-id', String(selectedVariant.id));
      });
      form.querySelectorAll('[name="quantity"]').forEach(input => {
        if (quantityLimit !== null) input.setAttribute('max', String(quantityLimit));
        else input.removeAttribute('max');
        constrainQuantity(input);
      });

      // Replace handlers when the same section is initialized again.
      if (form.warehouseChangeHandler) form.removeEventListener('change', form.warehouseChangeHandler, true);
      if (form.warehouseSubmitHandler) form.removeEventListener('submit', form.warehouseSubmitHandler, true);
      form.warehouseChangeHandler = function (event) {
        if (event.target.matches('[name="quantity"]')) constrainQuantity(event.target);
      };
      form.warehouseSubmitHandler = function (event) {
        if (root.warehouseValidationToken !== validationToken || !canBuy) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        // Ensure the cart always receives this store's variant, including direct URLs.
        form.querySelectorAll('[name="id"]').forEach(input => { input.value = String(selectedVariant.id); });
        form.querySelectorAll('[name="quantity"]').forEach(constrainQuantity);
      };
      form.addEventListener('change', form.warehouseChangeHandler, true);
      form.addEventListener('submit', form.warehouseSubmitHandler, true);
      // The theme's +/- controls emit jQuery change events, which do not run
      // native capture listeners. Apply the same bounds before its cart handler.
      if (window.jQuery) {
        window.jQuery(form)
          .off('change.warehouseQuantity', '[name="quantity"]')
          .on('change.warehouseQuantity', '[name="quantity"]', form.warehouseChangeHandler);
      }
    });
    await Promise.all([promotions, ...products]);
  }

  window.SuKarneWarehouseProducts = { initialize: initializeWarehouseProducts };

  if (window.jQuery) {
    window.jQuery(function () { initializeWarehouseProducts(document); });
    window.jQuery(window).on('cc-cart-updated.warehouse-promotions', function () { initializeWarehousePromotions(document); });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeWarehouseProducts(document); });
  } else {
    initializeWarehouseProducts(document);
  }
  document.addEventListener('shopify:section:load', event => initializeWarehouseProducts(event.target));
})();
